import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-page-not-found',
  imports: [RouterLink],
  templateUrl: 'page-not-found.component.html',
  styleUrl: '../../../../../static/styles/components/page-not-found.component.scss',
})
export class PageNotFoundComponent {
  @Input() backUrl = '/dashboard';
  @Input() btnText = 'Go back to dashboard';
  @Input() textClass = '';
  @Input() fullPage = true;
}
